import React, { useState, useEffect } from 'react'
import {
    Box, Card, CardContent, CardMedia, CardActions,
    Typography, Button, Skeleton, Snackbar, IconButton, Alert
} from '@mui/material/';
import { Context } from "../context/appContext";
import Tooltip from '@mui/material/Tooltip'
import { apiFetch } from "../hooks/useAuth";
import {
    buildContentShort,
    contentText,
    formatContentHtml,
    isLikelyIndexTruncated,
} from "../utils/descriptionText";
import { formatISBN, isbnDigits, normalizeIsbn } from "../utils/isbn";


export const ResultViewRight = ({ isbn, title, price, tax, engine }) => {

    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const handleAddToCart = () => {

        setIsAlertOpen(true);
    };

    const handleAlertClose = () => {
        setIsAlertOpen(false);
    };

    const { dispatch } = React.useContext(Context);

    // check if isbn is german
    const isGerman = isbn && isbn.startsWith("9783");
    const isMagazine = engine == "magazines";

    var toolTip = isGerman ? "" : isMagazine ? "Bitte im Freitext-Feld im Warenkorb den Abo-Typ angeben" : "Es handelt sich um einen Richtpreis für ausländische Bücher";

    const numberFormat = (value) =>
        new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
        }).format(value);

    var priceNew = isMagazine ? "auf Anfrage" : numberFormat(price);
    return (

        <>
            <Snackbar open={isAlertOpen} autoHideDuration={3000} onClose={handleAlertClose}>
                <Alert onClose={handleAlertClose} >
                    {`${title} wurde in den Warenkorb gelegt.`}
                </Alert>
            </Snackbar>

            <Typography gutterBottom variant="h5" color="text.secondary">


                <Tooltip className='' title={`${toolTip}`}>
                    <span className="material-icons" style={{ color: "grey" }}> {priceNew}{isGerman ? "" : "*"}</span>
                </Tooltip>
            </Typography>


            <Typography variant="body2" color="text.secondary">
                inkl. {tax}% MwSt.
            </Typography>

            <Button size="medium"
                onClick={() => dispatch({ type: "ADD_TO_WISH", payload: { "isbn": isbn, "title": title, "price": parseFloat(price), "tax": tax } })}
            >Merken</Button >

            <Button variant='contained'
                size="large"
                onClick={() => {
                    dispatch({ type: "ADD_TO_CART", payload: { "isbn": isbn, "title": title, "price": parseFloat(price), "tax": tax } });
                    handleAddToCart();

                }}
            >Bestellen</Button >
        </>


    );
}

export const ResultView = ({ item }) => {

    const [showMore, setShowMore] = useState(false);
    const [fullContent, setFullContent] = useState(item.content || "");
    const [loadingFullContent, setLoadingFullContent] = useState(false);
    const [loadedVlbContent, setLoadedVlbContent] = useState(false);

    const handleImageError = (e) => {
        e.target.onerror = null;
        // e.target.style.display = 'none'
        // e.target.src = "https://via.placeholder.com/200"
        e.target.src = "https://placehold.co/200"
    }

    useEffect(() => {
        setShowMore(false);
        setFullContent(item.content || "");
        setLoadedVlbContent(false);
    }, [item.id, item.content]);

    const loadVlbFullContent = async () => {
        const isbn = isbnDigits(item.isbn);
        const catalog = String(item.engine || "").toLowerCase();
        if (loadedVlbContent || catalog !== "vlb" || !isbn) {
            return fullContent;
        }

        setLoadingFullContent(true);
        try {
            const res = await apiFetch(`/app/vlb?q=${encodeURIComponent(isbn)}&p=1&c=10`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                },
            });
            const body = await res.json();
            const match = body?.content?.find(
                (entry) => normalizeIsbn(entry.isbn || entry.gtin) === isbn
            );
            if (match?.mainDescription) {
                setFullContent(match.mainDescription);
                setLoadedVlbContent(true);
                return match.mainDescription;
            }
        } catch (e) {
            console.error("VLB full text loading failed", e);
        } finally {
            setLoadingFullContent(false);
        }

        return fullContent;
    };

    const toggleDescription = async () => {
        if (showMore) {
            setShowMore(false);
            return;
        }

        await loadVlbFullContent();
        setShowMore(true);
    };

    // map 3 characters language code to cleartext in german für all languages

    ;
    const langMap = {
        "ger": "Deutsch",
        "eng": "Englisch",
        "fre": "Französisch",
        "ita": "Italienisch",
        "spa": "Spanisch",
        "por": "Portugiesisch",
        "rus": "Russisch",
        "pol": "Polnisch",
        "dut": "Niederländisch",
        "swe": "Schwedisch",
        "fin": "Finnisch",
        "dan": "Dänisch",
        "nor": "Norwegisch",
        "gre": "Griechisch",
        "tur": "Türkisch",
        "chi": "Chinesisch",
        "jpn": "Japanisch",
        "kor": "Koreanisch",
        "ara": "Arabisch",
        "heb": "Hebräisch",
        "hin": "Hindi",
        "tha": "Thailändisch",
        "vie": "Vietnamesisch",
        "ind": "Indonesisch",
        "per": "Persisch",
        "rum": "Rumänisch",
        "bul": "Bulgarisch",
        "cze": "Tschechisch",
        "slo": "Slowakisch",
        "hun": "Ungarisch",
        "est": "Estnisch",
        "lav": "Lettisch",
        "lit": "Litauisch",
        "slv": "Slowenisch",
        "mac": "Mazedonisch",
        "alb": "Albanisch",
        "arm": "Armenisch",
        "aze": "Aserbaidschanisch",
        "bel": "Weißrussisch",
        "bos": "Bosnisch",
        "geo": "Georgisch",
    }
    const productFormMap = {
        "AA": "Audio",
        "AC": "CD-Audio",
        "AE": "Karte",
        "BA": "Spiel",
        "BB": "Hardcover",
        "BC": "Softcover",
        "BD": "Heft",
        "BE": "Loseblattwerk",
        "BF": "Ordner",
        "BH": "Board Book",
        "BZ": "Box",
        "DA": "Kalender",
        "DI": "Kartei",
        "EA": "Digital",
        "ED": "Download",
        "PC": "Poster",
        "PD": "Puzzle",
        "PR": "Print",
        "SA": "Schreibwaren",
        "VI": "Video",
        "VO": "Vinyl",
        "WW": "Merchandise",
        "XE": "E-Book",
        "ZA": "Set",
        "ZE": "Zeitschrift",
        "ZJ": "Jugendbuch",
        "ZZ": "Sonstiges",
    };
    const catalogMap = {
        "vlb": "VLB",
        "libri": "Libri",
        "newbooks": "Newbooks",
        "magazines": "Zeitschriften",
    };
    const catalog = String(item?.engine || "").toLowerCase();
    const catalogLabel = catalogMap[catalog] || item?.engine;
    const contentShort = item.contentShort || buildContentShort(fullContent);
    const indexTruncated = isLikelyIndexTruncated(fullContent);
    const formattedFull =
        formatContentHtml(fullContent) +
        (showMore && indexTruncated && !loadedVlbContent ? " …" : "");
    const displayContent = showMore ? formattedFull : contentShort;
    const catalogIsVlb = String(item.engine || "").toLowerCase() === "vlb";
    const hasMoreContent =
        Boolean(contentText(fullContent)) &&
        (contentText(contentShort) !== contentText(fullContent) ||
            (catalogIsVlb && !loadedVlbContent));
    const contributorText = String(item.contributortext || "")
        .replace(/^((Autor\s*\/\s*Autorin|Autorin|Autor|Author)\s*:\s*)+/i, "")
        .trim();
    // console.log(item.coverUrl ? item.coverUrl : 'https://via.placeholder.com/100x150');


    return (


        <Card
            sx={{
                display: 'flex',
                flexDirection: { xs: "column", md: "row" },
                // alignItems: "center",
                // justifyContent: "center",
                p: 2,
                mb: 2,
                '& .markdown': {
                    py: 3,
                },
            }}
            key={item.id}
        >
            <Box

                sx={{
                    // backgroundColor: "#ddd",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    alignSelf: { md: "flex-start", xs: "center" },
                    mt: { xs: 0, md: 2 },
                }}
            >
                <CardMedia
                    component="img"
                    sx={{
                        // width: 150, 
                        width: { xs: "100%", sm: 350, md: 250 },
                        height: "auto",

                    }}
                    image={item.coverUrl ? item.coverUrl : 'https://via.placeholder.com/100x150'}
                    alt=""
                    onError={handleImageError}
                />
            </Box>

            <CardContent

                sx={{
                    flex: '1 100%',
                    // backgroundColor: "#eee",
                    flexWrap: "wrap",
                }}
            >
                <Typography gutterBottom variant="body2" color="text.secondary">

                    {contributorText && <><strong>Autor / Autorin: </strong>{contributorText}</>}

                    {/* {item.contributors &&
                                        item.contributors.map((contributor, contributorIndex) => {
                                            return (
                                                <>
                                                    {contributor.type}: {contributor.firstName} {contributor.lastName}
                                                </>
                                            );
                                        })} */}
                </Typography>

                <Typography gutterBottom variant="h5" component="h1">
                    {item.titleHtml ? (
                        <span dangerouslySetInnerHTML={{ __html: item.titleHtml }} />
                    ) : (
                        item.title
                    )}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    <strong>ISBN: </strong> {formatISBN(item.isbn)}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    <strong>Sprache: </strong> {langMap[item?.language] || item.language}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    <strong>Verlag: </strong> {item.publisher} {item.publishingYear && "(" + item.publishingYear + ")"}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    <strong>Format: </strong> {productFormMap[item?.productForm] || item?.productForm}
                </Typography>

                {catalogLabel &&
                    <Typography variant="body2" color="text.secondary">
                        <strong>Katalog: </strong> {catalogLabel}
                    </Typography>
                }
                {/* 
                <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
                    <strong>DEBUG: </strong><br /> File: {item.fn} <br />Imported: {item.dt} <br /> ISBN: {item.isbn} <br />Score: {item.score}
                </Typography> */}

                <Typography variant="body2" color="text.secondary">
                    {item.engine != "magazines" && item?.quantityStock && item.quantityStock > 0 && "Verfügbarkeit: " + item.quantityStock + " Exemplare"}
                    {item.engine == "magazines" && "... hier noch Text zu den Abo Modellen ..."}
                </Typography>


                {(displayContent || hasMoreContent) &&
                    <Typography
                        component="div"
                        sx={{ pt: 2 }}
                        gutterBottom
                        variant="body2"
                        color="text.secondary"
                    >
                        {displayContent &&
                            <span dangerouslySetInnerHTML={{ __html: displayContent }} />
                        }
                        {hasMoreContent && (
                            <>
                                {" "}
                                <Button
                                    sx={{ pl: 0, ml: 0, verticalAlign: "baseline", minWidth: 0 }}
                                    size="small"
                                    disabled={loadingFullContent}
                                    onClick={toggleDescription}
                                >
                                    {showMore
                                        ? "weniger"
                                        : loadingFullContent
                                          ? "lädt …"
                                          : "mehr"}
                                </Button>
                            </>
                        )}
                    </Typography>
                }

            </CardContent>

            <CardActions
                sx={{
                    flex: '1 0 150px',
                    alignSelf: { md: "flex-end" },
                    flexDirection: {
                        xs: "column",

                        // , md: "row"  
                    },
                }}
            >
                <ResultViewRight
                    price={item.price}
                    title={item.title}
                    isbn={item.isbn}
                    tax={item.tax}
                    engine={item.engine}
                    sx={{}}
                />

            </CardActions>

        </Card >

    );
}

function typesenseAuthorsText(doc) {
    if (!doc) return "";
    if (Array.isArray(doc.authors)) {
        return doc.authors.filter(Boolean).join(", ");
    }
    return doc.authors || "";
}

function typesenseHighlightSnippet(highlights, field) {
    if (!highlights || !Array.isArray(highlights)) return null;
    const h = highlights.find((x) => x.field === field);
    return h?.snippet || null;
}

function typesensePublishingYear(doc) {
    const year =
        doc.publishingYear ||
        doc.year ||
        doc.publishing_year ||
        doc.pub_year;
    if (year) {
        return String(year).slice(0, 4);
    }
    if (doc.pub_date) {
        return String(doc.pub_date).slice(0, 4);
    }
    return "";
}

export const ResultViewTypesense = ({ document: doc, highlights }) => {
    if (!doc) return null;

    const isbn = doc.isbn || doc.ISBN;
    const rawIsbn = isbn ? String(isbn).replace(/\D/g, "") : "";
    let coverUrl = doc.coverurl || doc.coverUrl;
    if (!coverUrl && rawIsbn.length >= 10) {
        coverUrl = `https://images.brunswiker.de/${rawIsbn.slice(-2)}/${rawIsbn}.jpg`;
    }

    const titleHtml = typesenseHighlightSnippet(highlights, "title");
    const authors = typesenseAuthorsText(doc);
    const desc =
        doc.summary ||
        doc.description ||
        doc.contents ||
        doc.content ||
        "";
    const contentShort = buildContentShort(desc);

    const item = {
        id: doc.id ?? rawIsbn ?? doc.title,
        isbn: rawIsbn || isbn,
        title: doc.title,
        titleHtml,
        contributortext: authors,
        content: desc,
        contentShort,
        price: doc.price_de ?? doc.pricede ?? doc.price ?? 0,
        tax: doc.price_de_tax ?? doc.taxde ?? doc.tax ?? 7,
        language: doc.lang || doc.language,
        publisher: doc.publisher,
        publishingYear: typesensePublishingYear(doc),
        pages: doc.pages,
        productForm: doc.productform || doc.productForm || doc.format,
        coverUrl,
        engine: doc.catalog || "",
    };

    return <ResultView item={item} />;
};

export const ResultViewElastic = (props, handleClick) => {

    if (!props.result) return (<></>);

    let coverUrl = props.result.coverurl?.raw;

    if (props.result.engine.raw == "vlb" || props.result.engine.raw == "libri" || props.result.engine.raw == "newbooks") {

        coverUrl = 'https://images.brunswiker.de/' + props.result.isbn.raw.slice(-2) + "/" + props.result.isbn.raw + ".jpg";
    }

    console.log(props);
    return (
        <ResultView
            item={{
                "id": props.result.id.raw,
                "isbn": props.result.isbn.raw,
                "title": props.result.title?.raw,
                "contributors": props.result?.contributor?.raw,
                "content": props.result.content?.raw,
                "contentShort": buildContentShort(props.result.content?.raw),
                "price": props.result?.pricede?.raw,
                "tax": props.result?.taxde?.raw,
                "language": props.result.language?.raw,
                "publisher": props.result.publisher?.raw,
                "publishingDate": props.result.publishingdate?.raw,
                "publishingYear": props.result.publishingdate?.raw ? parseInt(props.result.publishingdate?.raw) : "",
                "pages": props.result.pages?.raw,
                // cover: props.result.cover.raw,
                "contributortext": props.result.contributortext?.raw,
                "productForm": props.result?.productform?.raw,
                "coverUrl": coverUrl,
                "tax": props.result?.taxde?.raw,
                "engine": props.result?.engine.raw,
                "fn": props.result?.fn?.raw,
                "dt": props.result?.dt?.raw,
                "score": props.result?._meta?.score

            }}>

        </ResultView>
    )
}

export const ResultViewApiVLB = ({ item }) => {

    function getContributorText(item) {
        if (item.contributors) {
            let contributorText = "";
            item.contributors.forEach((contributor, index) => {
                contributorText += contributor.type + ": " + contributor.firstName + " " + contributor.lastName;
                if (index < item.contributors.length - 1) {
                    contributorText += ", ";
                }
            });
            return contributorText;
        }
    }

    return (

        <ResultView
            item={{
                "id": item.gtin,
                "isbn": item.isbn,
                "title": item.title,
                "contributors": item.contributors,
                "content": item.mainDescription,
                "contentShort": buildContentShort(item.mainDescription),
                "price": (item.priceEurD),
                "publisher": item.publisher,
                "pubslishingDate": item.publicationDate,
                "publishingYear": item.publicationDate.split(".")[2],
                "tax": item.taxKeyEurD == "1" ? 7 : 19,

                // cover: props.result.cover.raw,
                "contributortext": getContributorText(item),
                "language": item.language,
                "productForm": item.productForm,
                "productType": item.productType,
                "pages": item.pagesArabic,
                "coverUrl": 'https://europe-west1-litport-web.cloudfunctions.net/app/cover/' + item.gtin,
                "engine": "vlb",
            }}>
        </ResultView>
    )
}


export const ResultViewApiLibri = ({ item }) => {

    function getPriceForDe(item) {

        if (item.prices) {
            let priceDE = 0;
            item.prices.forEach((price, index) => {

                if (price.countriesIncluded[0] == "DE") {
                    priceDE = price.priceAmount;
                }
            });
            return priceDE;
        }
    }


    function getTaxForDe(item) {

        if (item.prices) {
            let priceDE = 0;
            item.prices.forEach((price, index) => {

                if (price.countriesIncluded[0] == "DE") {
                    priceDE = price.taxRateCode;

                }
            });
            return priceDE;
        }
    }
    //console.log(item);



    const taxRateCodeToPercent = (taxRateCode) => {
        switch (taxRateCode) {
            case "R":
                return 7;
            case "S":
                return 19;
            case "C":
                return 0;
            default:
                return 0;
        }
    }


    return (

        <ResultView
            item={{
                "id": item.primaryEAN,
                "isbn": item.primaryEAN,
                "title": item.title,
                "contributors": item.contributors,
                "content": item.mainDescription,
                "contentShort": buildContentShort(item.mainDescription),
                "price": (getPriceForDe(item)),
                "publisher": item.publisherName,
                "publishingDate": item.publishingDate.date,
                "publishingYear": item.publishingDate.date.split("-")[0],

                // cover: props.result.cover.raw,
                "contributortext": item.mainContributor,
                "language": item.language,
                "productForm": item.productForm,
                "productType": item.productType,
                "pages": item.pagesArabic,
                "quantityStock": item.libriStockQuantityCoded,
                "tax": taxRateCodeToPercent(getTaxForDe(item)),
                "coverUrl": item.coverImages ? item.coverImages[0].uri : "",
                "engine": "libri",
            }}>
        </ResultView>
    )
}